export default __webpack_public_path__ + "static/media/Buy.58f0b045.svg";